const en = {
	common: {
		Travelnest: 'Travelnest',
		back: 'Back',
	},
	Header: {
		hostedBy: 'hosted by',
	},
	SecurityDeposit: {
		title: 'This property requires a {symbol}{securityDeposit} refundable security deposit, which will be collected separately by the host either before your arrival or at check-in.',
	},
	PaymentLink: {
		StaySummary: {
			title: 'Your booking',
			reservationId: 'Reservation/Booking ID',
			checkInOut: 'Check-in/out',
			guests: 'Guests',
			total: 'Total for your stay',
		},
	},
	GuestDetails: {
		title: 'Billing information',
		fullName: 'Full Name (as on card)',
		billingAddress: 'Billing Address',
		billingAddress2: 'Address Line 2 (Optional)',
		billingCity: 'City',
		billingPostcode: 'Postcode / ZIP code',
		billingCountry: 'Country',
		cardDetails: 'Card details',
		cardIcons: {
			visa: 'Visa',
			mastercard: 'Mastercard',
			amex: 'American Express',
		},
		contactSupport: "Questions about your payment? We're here to help.",
		contactSupportLink: 'Contact Support',
	},
	PageFooter: {
		poweredBy: 'Powered by',
		termsAndConditions: 'Terms and conditions',
		privacyPolicy: 'Privacy policy',
	},
	confirmedSummary: {
		title: 'Your booking is confirmed',
		description:
			'We are pleased to let you know that your booking at {property} is confirmed.',
		confirmationEmail:
			'You will receive a confirmation email shortly with these details.',
		bookingDetails: 'Your booking details',
		reservationId: 'Reservation/Booking ID',
		checkInOut: 'Check-in/out',
		guests: 'Guests',
		total: 'Total paid ({currency})',
		reservation: 'Reservation/Booking ID',
		property: 'Property ID',
		checkIn: 'Check-in',
		checkOut: 'Check-out',
		paymentForThisBooking: 'Payment for this booking',
		bankStatement:
			'Your payment will show up on your bank or card statement as MGP*Travelnest VRBO.',
		arrivalDetails:
			'To confirm your arrival details and arrange access to the property, please get in touch and say ‘Hi’ to the owner of this property before your stay. If you have a special request (e.g. to change the check-in time / bring a pet) or have a question about the property, please get in touch with your host.',
		email: 'Email',
		phone: 'Phone',
		address: 'Address',
		thanks: 'Thanks again for booking with us and we hope you have a lovely stay!',
		host: '{hostName} is your host',
	},
	cancelledSummary: {
		title: 'Your booking has been cancelled',
		description: 'Your booking at {property} has been cancelled.',
		bookingDetails: 'Your booking details',
		reservationId: 'Reservation/Booking ID',
		checkInOut: 'Check-in/out',
		guests: 'Guests',
		total: 'Total paid ({currency})',
		reservation: 'Reservation/Booking ID',
		thanks: 'We hope you book with us again soon; see more of our properties on {vrboLink}.',
		property: 'Property ID',
		checkIn: 'Check-in',
		checkOut: 'Check-out',
		paymentForThisBooking: 'Payment for this booking',
		vrboName: 'Vrbo',
	},
	pages: {
		payment: {
			head: {
				title: 'Pay for {property}',
			},
		},
		linkExpired: {
			title: 'Payment link expired',
			description:
				"Looks like this payment link has expired, we probably didn't receive your payment in time, so the reservation has been cancelled.",
			supportText: 'Need help? {contactLink}.',
			contactLink: 'Contact Travelnest Support',
		},
		notFound: {
			title: "Hmm… Something's not right",
			description:
				"We couldn't recognise this payment link, it may be incorrect or no longer valid. If you're trying to pay for a booking, please check the link and try again.",
			supportText:
				"Still stuck? We're happy to help, contact {contactLink} and we'll look into it for you.",
			contactLink: 'Travelnest Support',
		},
	},
} as const;

export default en;
